const Constants = {
  endpointBasePath: "/index-types",
  indexGroupBasePath: "/index-type-groups",
  indexCategoryBasePath: "/index-type-categories",
  childGroupsPath: "/child-groups",
  itemsPath: "/items",
  indexTypeAttributePath: "/index-type-attribute"
};

export default Constants;
